import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ProductImage } from './ProductImage';
import { ProductDetail } from './ProductDetail';

export interface Props {
  src: string;
  reverse?: boolean;
  first?: boolean;
  last?: boolean;
  title: string;
  code: string;
  videoId?: string;
  codeDisplay?: string;
  features: string[];
  specs: string[];
}

export const Product = React.memo(
  ({
    src,
    reverse,
    last,
    first,
    title,
    code,
    codeDisplay,
    videoId,
    features,
    specs,
  }: Props) => {
    return (
      <Flex
        id={code}
        flexDirection={{
          base: 'column-reverse',
          md: reverse ? 'row-reverse' : 'row',
        }}
        alignItems="center"
      >
        <ProductImage src={src} />
        <ProductDetail
          last={last}
          first={first}
          title={title}
          code={codeDisplay || code}
          videoId={videoId}
          features={features}
          specs={specs}
        />
      </Flex>
    );
  },
);
